import { render, staticRenderFns } from "./itemTraduccion.vue?vue&type=template&id=e3893cbe&scoped=true&"
import script from "./itemTraduccion.vue?vue&type=script&lang=js&"
export * from "./itemTraduccion.vue?vue&type=script&lang=js&"
import style0 from "./itemTraduccion.vue?vue&type=style&index=0&id=e3893cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3893cbe",
  null
  
)

export default component.exports